import i18n from "../i18n";

export const requestTypesList = {
  RefuseDelivery: "Отмена рейса",
  RequestChangeApprovedDeliveryDate: "Запрос на изменение даты одобренной заявки на рейс",
  ChangingRequisites: "Изменение реквизитов",
  ApproveRollback: "Откат согласования",
  ShipperCompanyContractRollback: "Откат договора",
  DeliveryLoadingRollback: "Возвращение рейса на погрузку",
  ChangingLogin: "Изменение логина",
  ReturningDeliveryFromArchive: "Возвращение рейса из архива",
  ChangingPartnerType: "Изменение типа партнера",
  DeliverySetNoNeedAddParams: "Убрать требование фото у рейса",
  AllowInternationalDelivery: "Аккредитация на международные рейсы",
  ShipperCompanyContractArchive: "Расторжение согласованного договора"
}

export const approveAction = {
  1: "На согласовании",
  2: "Согласование от Логист",
  3: "Согласование от Юрист",
  4: "Отклонено по причине:",
  5: "Согласование от Бухгалтер",
  6: "Согласование под личную ответственность"
}

export const unloadPackageTypes = {
  1: 'Валом',
  2: 'На паллетах',
  3: 'Запаллеченный товар плюс вал',
  4: 'Вал с вложенными паллетами',
  5: 'Европаллет'
}

export const carcassTypes = {
  2: "Рефрижератор +12 — 0",
  3: "Рефрижератор +12 — -10",
  4: "Рефрижератор +12 — -20",
  5: "Тент",
  6: "Фургон",
  7: "Изотерм",
  9: "Контейнер 20 футов",
  10: "Контейнер 40 футов",
  11: "Цельнометаллический",
  99: "Без режима"
}

export const companyTypes = {
  2: "Экспедитор",
  1: "Собственник автотранспорта",
  6: "Транспортная компания",
  4: "Грузовладелец"
}

export const contractStatus = {
  1: "На согласовании",
  2: "Подтверждено",
  4: "Ожидает скан подписанного договора",
  3: "Отклонено"
}

export const contractEdoStatus = {
  draft: "В работе у перевозчика",
  docflow: "Ожидает подписания грузоотправителем",
  completed: "ЭДО подписаны",
}

export const logistActionStatus = {
  offers: "Встречное предложение",
  approved: "Подтверждено",
  declined: "Отклонен"
}

export const orderStatus = {
  approved: "Согл.",
  declined: "Откл."
}

export const reportPeriod = {
  24: "менее 24 часов",
  48: "24-48 часов",
  72: "48-72 часов",
  more72: "более 72 часов"
}

export const getTranslatedConstant = (constantName) => {
  const allConst = {
    defaultSort: [
      {
        name: "default",
        title: i18n.t('components.filter.sort.default'),
      },
      {
        name: "new_desc",
        title: i18n.t('components.filter.sort.newDesc'),
      },
      {
        name: "new_asc",
        title: i18n.t('components.filter.sort.newAsc'),
      },
      {
        name: "price_desc",
        title: i18n.t('components.filter.sort.priceDesc'),
      },
      {
        name: "price_asc",
        title: i18n.t('components.filter.sort.priceAsc'),
      },
    ],
    packageTypesList: [
      {Id: 'Валом', Name: i18n.t('consignorPage.createDelivery.packageTypesList.1')},
      {Id: 'Паллеты', Name: i18n.t('consignorPage.createDelivery.packageTypesList.2')},
    ],
    loadingTypesList: [
      {Id: 'Задняя', Name: i18n.t('consignorPage.createDelivery.loadingTypesList.1')},
      {Id: 'Верхняя', Name: i18n.t('consignorPage.createDelivery.loadingTypesList.2')},
      {Id: 'Боковая', Name: i18n.t('consignorPage.createDelivery.loadingTypesList.3')},
      {Id: 'Растентовка', Name: i18n.t('consignorPage.createDelivery.loadingTypesList.4')},
    ],
    staffStatusList: {
      active: i18n.t('constants.staffStatus.active'),
      deleted: i18n.t('constants.staffStatus.deleted'),
      archive: i18n.t('constants.staffStatus.archive')
    },
    requestTypesList: {
      RefuseDelivery: i18n.t('constants.requestTypesList.RefuseDelivery'),
      RequestChangeApprovedDeliveryDate: i18n.t('constants.requestTypesList.RequestChangeApprovedDeliveryDate'),
      ChangingRequisites: i18n.t('constants.requestTypesList.ChangingRequisites'),
      ApproveRollback: i18n.t('constants.requestTypesList.ApproveRollback'),
      ShipperCompanyContractRollback: i18n.t('constants.requestTypesList.ShipperCompanyContractRollback'),
      DeliveryLoadingRollback: i18n.t('constants.requestTypesList.DeliveryLoadingRollback'),
      ChangingLogin: i18n.t('constants.requestTypesList.ChangingLogin'),
      ReturningDeliveryFromArchive: i18n.t('constants.requestTypesList.ReturningDeliveryFromArchive'),
      ChangingPartnerType: i18n.t('constants.requestTypesList.ChangingPartnerType'),
      DeliverySetNoNeedAddParams: i18n.t('constants.requestTypesList.DeliverySetNoNeedAddParams'),
      AllowInternationalDelivery: i18n.t('constants.requestTypesList.AllowInternationalDelivery'),
      ShipperCompanyContractArchive: i18n.t('constants.requestTypesList.ShipperCompanyContractArchive')
    },
    approveStatus: {
      1: i18n.t('constants.approveStatus.1'),
      2: i18n.t('constants.approveStatus.2'),
      3: i18n.t('constants.approveStatus.3')
    },
    contractGroupTypes: {
      container: i18n.t('constants.contractGroupTypes.container'),
      carriage: i18n.t('constants.contractGroupTypes.carriage'),
      cross_dock: i18n.t('constants.contractGroupTypes.cross_dock'),
    },
    approveAction: {
      1: i18n.t('constants.approveAction.1'),
      2: i18n.t('constants.approveAction.2'),
      3: i18n.t('constants.approveAction.3'),
      4: i18n.t('constants.approveAction.4'),
      5: i18n.t('constants.approveAction.5'),
      6: i18n.t('constants.approveAction.6')
    },
    unloadPackageTypes: {
      1: i18n.t('constants.unloadPackageTypes.1'),
      2: i18n.t('constants.unloadPackageTypes.2'),
      3: i18n.t('constants.unloadPackageTypes.3'),
      4: i18n.t('constants.unloadPackageTypes.4'),
      5: i18n.t('constants.unloadPackageTypes.5')
    },
    mode: {
      2: i18n.t('constants.mode.2'),
      3: i18n.t('constants.mode.3'),
      4: i18n.t('constants.mode.4'),
      5: i18n.t('constants.mode.5'),
      6: i18n.t('constants.mode.6'),
      7: i18n.t('constants.mode.7'),
      9: i18n.t('constants.mode.9'),
      10: i18n.t('constants.mode.10'),
      11: i18n.t('constants.mode.11'),
      99: i18n.t('constants.mode.99')
    },
    companyTypes: [
      {id: 2, name: i18n.t('consignorPage.companiesList.filter.companyTypes.values.2')},
      {id: 1, name: i18n.t('consignorPage.companiesList.filter.companyTypes.values.1')},
      {id: 6, name: i18n.t('consignorPage.companiesList.filter.companyTypes.values.6')},
      {id: 4, name: i18n.t('consignorPage.companiesList.filter.companyTypes.values.4')}
    ],
    logistActionStatus: {
      offers: i18n.t(`reportsPage.statsLogistsResponseToOrders.status.offers`),
      approved: i18n.t(`reportsPage.statsLogistsResponseToOrders.status.approved`),
      declined: i18n.t(`reportsPage.statsLogistsResponseToOrders.status.declined`)
    },
    orderStatus: {
      approved: i18n.t(`reportsPage.statsOrdersDeliveryByTime.table.orderStatus.values.approved`),
      declined: i18n.t(`reportsPage.statsOrdersDeliveryByTime.table.orderStatus.values.declined`)
    },
    reportPeriod: {
      24: i18n.t('reportsPage.statsFreeDeliveries.table.period.values.24'),
      48: i18n.t('reportsPage.statsFreeDeliveries.table.period.values.48'),
      72: i18n.t('reportsPage.statsFreeDeliveries.table.period.values.72'),
      more72: i18n.t('reportsPage.statsFreeDeliveries.table.period.values.more72')
    }
  }
  return allConst[constantName];
}

export const getTranslatedCountries = (countries) => {
  if (countries.length > 0) {
    return countries.map((item) => {
      return Object.assign({}, item, {Name: i18n.t(`constants.countryList.${item.Id}`)});
    })
  } else {
    return countries;
  }
}
